module.exports = __webpack_public_path__ + "31e5007975be169b22ac66a7e48af826.mp4";